export default __webpack_public_path__ + "static/media/tt.170f5ca7.svg";